/** A RPC retorna o total ainda não consumido, incluindo os créditos reservados. */
export const creditosLivres = (saldo?: { disponivel: number; reservado?: number } | null): number =>
  Math.max(0, (saldo?.disponivel ?? 0) - (saldo?.reservado ?? 0));
